import { Container } from "@mozioinc/ui";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// import { ReactComponent as EsimSvg } from "./assets/esim.svg";
// import { ReactComponent as SmsSvg } from "./assets/sms.svg";
import { parkingQuery } from "../utils/query";
import { PurchaseSummary } from "./purchase-summary";
import {
  ResendConfirmationButton,
  useCounter,
} from "./resend-confirmation-button";
import type { ParkingReservation } from "@mozioinc/query";

// const notificationTypes = [
//   {
//     icon: <SmsSvg className="h-[30px] w-[30px]" />,
//     title: "SMS Notifications",
//     description:
//       "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestiae, distinctio?", // cspell:disable-line
//   },
//   {
//     icon: <EsimSvg className="h-[30px] w-[30px]" />,
//     title: "eSIM Thailand",
//     description:
//       "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestiae, distinctio?", // cspell:disable-line
//   },
// ];

type ConfirmationProps = {
  reservation?: ParkingReservation;
};

const Confirmation = ({ reservation }: ConfirmationProps) => {
  const { t } = useTranslation("parking:purchase-summary");
  const [isResending, setIsResending] = useState(false);
  const { counter, startCounter } = useCounter(() => setIsResending(false));

  const { refetch: resendQuery } = useQuery({
    queryKey: ["resendNotification", reservation?.id],
    queryFn: () =>
      parkingQuery.resendNotification({ reservationId: reservation?.id ?? "" }),
    enabled: false,
  });

  if (!reservation) {
    return;
  }

  const resendNotification = () => {
    startCounter();
    setIsResending(true);
    resendQuery();
  };

  return (
    <div className="flex flex-1 items-center bg-white sm:bg-neutral-100">
      <Container className="mt-2 w-full max-w-2xl flex-1 rounded-lg bg-white p-5">
        <div>
          <div className="rounded-md bg-green-500 p-4 text-white">
            <h1 className="text-2xl font-bold">
              {t("{{customerName}}, your parking is confirmed", {
                customerName: reservation.customer?.firstName,
              })}
            </h1>
            <p className="text-sm">
              {t(
                "A confirmation email with your booking details was sent to {{customerEmail}}",
                {
                  customerEmail: reservation.customer?.email,
                },
              )}
            </p>
          </div>
          <div className="bg-white pb-5 pt-5">
            {" "}
            <h1 className="mb-4 text-2xl font-bold">
              {t("Reservation details")}
            </h1>
          </div>
          <PurchaseSummary
            className="mb-7 p-0"
            location={reservation.location}
            name={reservation.parkingName}
            showPrice={false}
            arrivalDateTime={new Date(reservation.arrivalDateTime)}
            departureDateTime={new Date(reservation.departureDateTime)}
          />
          {/* <div className="w-full pl-[1.95rem]">
              {notificationTypes.map((notificationType) => {
                return (
                  <NotificationType
                    key={notificationType.title}
                    icon={notificationType.icon}
                    title={notificationType.title}
                    description={notificationType.description}
                  />
                );
              })}
            </div> */}
          {/* // TODO: Check with the team if we need any CTA on this page or just hide it. */}

          <p className="text-base font-bold">
            {isResending
              ? t("Confirmation email sent!")
              : t("Didn't receive the notification email?")}
          </p>
          <ResendConfirmationButton
            onButtonClick={resendNotification}
            countdown={counter}
          />
        </div>
      </Container>
    </div>
  );
};

// type NotificationTypeProps = {
//   title: string;
//   description: string;
//   icon: React.ReactNode;
// };

// const NotificationType = ({
//   title,
//   description,
//   icon,
// }: NotificationTypeProps) => {
//   return (
//     <div className="mb-5 mt-5 flex ">
//       <div className="w-[40px] pb-3 pt-3">{icon}</div>
//       <div className="flex-grow border-t border-gray-500 pb-3 pt-3">
//         <p className="text-xl font-semibold">{title}</p>
//         <p className="text-sm">{description}</p>
//       </div>
//     </div>
//   );
// };

export { Confirmation };
